import { useAppContext } from '@/context';
import { logout } from '@/utils/auth';
import { getJson } from '@/utils/fetchOptions';

import { useQuery } from '..';

const DEV_MOCK = [
  {
    id: '1',
    name: 'Tasters',
    description: 'Includes pictures of stakes, butter and chefs',
    categories: ['chef', 'food'],
    image:
      'https://cdnnew.foody.com.cy/cdn-cgi/image/f=auto/shop/2443/cover?t=1647428855&platform=web'
  },
  {
    id: '2',
    name: 'Skål',
    description: 'Includes pictures of stakes, butter and chefs',
    categories: ['chef', 'food'],
    image:
      'https://www.shutterstock.com/image-photo/close-two-people-cheering-cocktails-600nw-2293553721.jpg'
  },
  {
    id: '3',
    name: 'Nice cars',
    description: 'Just a lot of Audi & Porsche',
    categories: ['auto'],
    image:
      'https://static.cdn-expressen.se/images/3d/95/3d95e2ee9a064075a425dd90b0ad7273/annan/2560.jpg'
  }
];

export function useInfluencerPlaylists(id: string) {
  const { setAlert } = useAppContext();

  const { data, error, isLoading } = useQuery({
    queryKey: `influencer-playlists-${id}`,
    queryFn: async () => {
      if (!id) return [] as Api.Influencer.Playlist[];

      if (process.env.NODE_ENV !== 'production' && id === '1') {
        return DEV_MOCK;
      }

      const response = await getJson({
        url: `${process.env.NEXT_PUBLIC_BEATLY_API_URL}/app/v2/influencer/playlists/${id}`
      });

      if ((response as ResponseExpiredToken).isExpired) {
        logout();
      }
      if ('code' in (response as TypeAny)) {
        setAlert((response as ResponseObject).code);
      }

      return response as Api.Influencer.Playlist[];
    },
    enabled: !!id
  });

  return {
    data: data as Api.Influencer.Playlist[],
    isLoading,
    error
  };
}
